var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7031 9.81219C16.3782 9.81219 16.1267 10.0626 16.1267 10.389V18.2683H12.0392V15.0509C12.0392 14.749 11.7877 14.4852 11.4836 14.4852H8.52819C8.20309 14.4852 7.94125 14.749 7.94125 15.0509V18.2683H3.8641V10.6506C3.8641 10.3465 3.6128 10.0939 3.2877 10.0939C2.98384 10.0939 2.7323 10.3465 2.7323 10.6506V18.8452C2.7323 19.1493 2.98384 19.4019 3.2877 19.4019H8.52819C8.83204 19.4019 9.08358 19.1493 9.08358 18.8452V15.6277H10.9072V18.8452C10.9072 19.1493 11.1587 19.4019 11.4836 19.4019H16.7031C17.007 19.4019 17.2585 19.1493 17.2585 18.8452V10.3891C17.2585 10.0627 17.007 9.81219 16.7031 9.81219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8367 10.2616L15.2882 5.69368V2.57908C15.2882 2.25486 15.0261 2.00447 14.7012 2.00447C14.3971 2.00447 14.1456 2.25489 14.1456 2.57908V4.55115L10.3936 0.776943C10.2786 0.660668 10.142 0.598053 10.0059 0.598053C9.84868 0.598053 9.71231 0.66289 9.59714 0.776943L0.175071 10.199C-0.0509761 10.4248 -0.0659435 10.787 0.175071 10.995C0.384582 11.2365 0.745466 11.2208 0.971513 10.995L10.0059 1.98208L19.0192 11.08C19.1131 11.1739 19.2497 11.2275 19.4279 11.2275C19.5851 11.2275 19.7213 11.1739 19.8367 11.08C20.0464 10.8698 20.062 10.4897 19.8367 10.2616Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoti);
export default __webpack_public_path__ + "static/media/koti.178e53fc9f23c335261dc97e90ca752c.svg";
export { ForwardRef as ReactComponent };